module.exports = __webpack_public_path__ + "assets/img/catalog.7b139d3b.jpg";